import { Box } from '@chakra-ui/react';
import { tableList } from './const';
import SearchBar from '@components/searchBar';
import TableAddItem from '@components/TableAddItem';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { debounce, some } from 'lodash';
import { useSnackbarNotification } from '@store/snackbarNotification';
import {
    useGetCustomerList,
    useGetInfiniteCustomerList,
} from '@pages/ConsumerPromotion/hooks/query/useGetCustomerList';
import { useEffect } from 'react';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePaginationCust';

export default function Table() {
    const stateEdit = useEditDetail();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const allData = usePaginationStore((s) => s.data);
    const page = usePaginationStore((s) => s.page);
    const limit = usePaginationStore((s) => s.limit);
    const pageCount = Math.max(1, Math.ceil(allData.length / limit));
    const { setData, setLimit, setPage, editItem } = usePaginationStore();

    const start = (page - 1) * limit;
    const paginatedData = allData.slice(start, start + limit);
    const total = usePaginationStore((s) => s.total());

    const { data, isLoading } = useGetCustomerList({
        id: stateEdit?.id,
        limit: 999999999,
        page: stateEdit?.page,
        search: stateEdit?.searchCustomer,
    });

    const {
        data: infiniteData,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        isLoading: isLoadingInfiniteData,
    } = useGetInfiniteCustomerList(stateEdit?.searchMasterDataCustomer, stateEdit?.id);

    const onSelectItem = (value) => {
        const exists = some(allData, { customer_id: value.customer_id });

        if (exists && !stateEdit?.editingRowCustomer) {
            return onChangeSnackbarNotification({
                status: 'error',
                description: 'Customer sudah ditambahkan!',
                duration: 3,
            });
        }

        if (stateEdit?.editingRowCustomer) {
            editItem(stateEdit.editingRowCustomer.id, value);
            stateEdit.set({ editingRowCustomer: null });
            return;
        }

        setData([...allData, value]);
    };

    const onSearchItem = debounce((value) => {
        stateEdit.set({
            searchMasterDataCustomer: value,
        });
    }, 500);

    const handleSearchTable = debounce((e) => {
        const searchTable = e.target.value.toLowerCase();
        stateEdit.set({ searchCustomer: searchTable });
    }, 500);

    const onChangeLimit = (e) => {
        setLimit(e.target.value);
    };

    const handlePageChange = ({ selected }) => {
        setPage(selected + 1);
    };

    useEffect(() => {
        if (data) {
            stateEdit.set({
                page_cust: data?.current_page,
                total_page_cust: data?.total_page,
                customer_list: data?.page_data,
            });
        }
    }, [data]);

    useEffect(() => {
        if (data) {
            setData(data?.page_data);
        }
    }, [data]);

    return (
        <Box>
            <SearchBar placeholder={'Cari nama customer'} mb={'24px'} onChange={handleSearchTable} />

            <TableAddItem
                tableList={tableList}
                data={paginatedData}
                isLoading={isLoading}
                isHideAction={false}
                noDataDescription="Saat ini, data customer belum diinput."
                // * props add item to table
                queryAddItem={infiniteData}
                isLoadingQueryItem={isLoadingInfiniteData}
                isAddItem={stateEdit.isEditCustomer}
                onSearchItem={onSearchItem}
                onSelectItem={onSelectItem}
                groupBy={false}
                editingRow={stateEdit?.editingRowCustomer}
                fetchNextPage={fetchNextPage}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                addBtnLabel={'Tambah Customer'}
                placeholder={'Cari ID atau nama Customer ...'}
                // * props pagination
                totalData={total}
                limit={limit}
                page={page}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                onChangeLimit={onChangeLimit}
            />
        </Box>
    );
}
